import styles from './header-logo.module.scss';
import { useDispatch } from 'react-redux';
import { displayFlyingButton } from '../../../redux/display-slice';

interface LogoProps {
	src: string
	link?: string
}

export function HeaderLogo({src, link}:LogoProps) {
	const dispatch = useDispatch();

	return (
		<a className={styles.link} rel='noopener noreferrer' target="_blank" href={link || '#'}>
      <img 
        className={styles.image} 
        src={src}
        alt=""
        onMouseEnter={() => dispatch(displayFlyingButton(false))}
        onMouseLeave={() => dispatch(displayFlyingButton(true))}
      />
    </a>
  )
}